import type {
    CompleteCommerceEnrollmentStageRequest,
    CompleteCommerceEnrollmentStageResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const completeCommerceEnrollmentStageOperation: CommerceOperation<
    CompleteCommerceEnrollmentStageRequest,
    CompleteCommerceEnrollmentStageResponse
> = Object.freeze({ name: "commerce.enrollment.stage.complete" });
